import { createSyncObservable, useObservable, useOnNavigation } from '@avensia/excite';
import * as React from 'react';

const [observable] = createSyncObservable<number>(1);

export function useQuantity(initialQuantity?: number, close?: () => void) {
  const quantity = useObservable(observable);
  if (typeof initialQuantity === 'number') {
    observable.emit(initialQuantity);
  }

  const updatedQuantity = React.useCallback((newQuantity: number) => {
    observable.emit(newQuantity);
  }, []);

  useOnNavigation(close ? close : () => ({}));

  return { quantity, updatedQuantity };
}
